import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fetchAllReports, resetAdminReports, resetAdminReportsThunk } from '../../store/slices/gameTestingSlice';
import AnalyticsReportsList from './components/AnalyticsReportsList';
import './TestingAnalytics.scss';

const TestingAnalytics = () => {
  const dispatch = useDispatch();
  
  useEffect(() => {
    // Reset reports when component mounts
    dispatch(resetAdminReports());
    dispatch(resetAdminReportsThunk());
    
    // Fetch initial reports
    dispatch(fetchAllReports({ 
      itemsPerPage: 10,
      lastVisible: null,
      filters: {}
    }));
    
    // Cleanup when component unmounts
    return () => {
      dispatch(resetAdminReports());
      dispatch(resetAdminReportsThunk());
    };
  }, [dispatch]);
  
  return (
    <div className="testing-analytics-container">
      <section className="page-heading">
        <div className="d-flex justify-content-between align-items-center">
          <h3 className="mb-0">Testing Analytics Dashboard</h3>
        </div>
      </section>
      
      <div className="testing-analytics-content">
        <AnalyticsReportsList />
      </div>
    </div>
  );
};

export default TestingAnalytics; 